// @flow

import { hpfetch } from '../util';
import type {
  djangoModelApiResponse,
  wrappedApiResponseType,
} from '../apiTypes';
import type { questionType } from '../../types';

export const getSingle = (
  offeringId: number,
  id: number,
): Promise<wrappedApiResponseType<questionType>> =>
  hpfetch(`offerings/${offeringId}/questions/${id}/`);

export const getMany = (
  offeringId: number,
  limit: number = 100,
  offset: number = 0,
): djangoModelApiResponse<questionType> =>
  hpfetch(`offerings/${offeringId}/questions/?limit=${limit}&offset=${offset}`);

export const create = (
  offeringId: number,
  question: string,
  publicBuyer: boolean,
): Promise<wrappedApiResponseType<questionType>> =>
  hpfetch(`offerings/${offeringId}/questions/`, {
    method: 'POST',
    body: JSON.stringify({ question, public_buyer: publicBuyer }),
  });

export const update = (
  offeringId: number,
  questionId: number,
  answer: string,
  publicSeller: boolean,
): Promise<wrappedApiResponseType<questionType>> =>
  hpfetch(`offerings/${offeringId}/questions/${questionId}/`, {
    method: 'PATCH',
    body: JSON.stringify({ answer, public_seller: publicSeller }),
  });
